export default ({ appColors }) => {
    return (
        <>
            <style>
                .bg_color,body{`{background-color: ${appColors.bg}}`}
                .navbar,#video_player_live,.MainModal{`{background-color:${appColors.menuColor}}`}
                .bottom_field_controles,.parentModal,.top_field_controls{`{background-color:${appColors.gradient_bg}}`}
                .card_color,.category_live,.main_epg_live{`{background-color:${appColors.cardColor}}`}
                .card_color:hover,.errorMessage{`{background-color:${appColors.selectedRowColor}}`}
                input:focus {`{box-shadow:0 0 0 0.2rem #38334d, 0 0 0 0.4rem ${appColors.selectColor}}`}
                .shadow_days_epg{`{box-shadow:inset -1.5rem 0 1rem  ${appColors.selectedRowColor}}`}
            </style>
        </>
    )
}